export default {
  title: '货物类型（品名）管理',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '代码、中文名称、英文名称',
    status: '状态',
    statusPlaceholder: '选择状态',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    add: '新增货物类型',
    edit: '编辑',
    delete: '删除',
    enableItem: '启用',
    disableItem: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    code: '代码',
    nameCn: '中文名称',
    nameEn: '英文名称',
    sortOrder: '排序',
    source: '数据来源',
    status: '状态',
    remark: '备注',
    operation: '操作'
  },

  // 数据来源
  source: {
    platform: '平台',
    tenant: '租户'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  // 弹窗
  modal: {
    addTitle: '新增货物类型',
    editTitle: '编辑货物类型'
  },

  // 表单
  form: {
    code: '代码',
    codePlaceholder: '请输入代码，如 FURNITURE',
    nameCn: '中文名称',
    nameCnPlaceholder: '请输入中文名称',
    nameEn: '英文名称',
    nameEnPlaceholder: '请输入英文名称（选填）',
    sortOrder: '排序',
    status: '状态',
    remark: '备注',
    remarkPlaceholder: '请输入备注（选填）'
  },

  // 表单验证
  validation: {
    codeRequired: '请输入代码',
    nameCnRequired: '请输入中文名称'
  },

  // 确认
  confirm: {
    toggleStatus: '确定要{action}此货物类型吗？',
    delete: '确定要删除此货物类型吗？'
  },

  // 消息提示
  messages: {
    loadError: '数据加载失败',
    createSuccess: '新增成功',
    updateSuccess: '更新成功',
    saveError: '保存失败',
    deleteSuccess: '删除成功',
    deleteError: '删除失败',
    statusToggleSuccess: '状态切换成功',
    statusToggleError: '操作失败'
  }
}
